<template>
    <transition :css="false" @enter="intro" @leave="outro">
        <div class="MenuRibbon" v-show="ribbonVisible">
            <div
                ref="closeBttn"
                @click="backToHome"
                class="MenuRibbon-bttn--close"
            >
                <span class="MenuBttn-line top"></span>
                <span class="MenuBttn-line bottom"></span>
            </div>

            <div class="MenuRibbon-back" ref="back"></div>
            <div
                ref="bttn"
                @click="openNav"
                class="MenuRibbon-bttn"
                :class="{open: !isInHome}"
            >
                <span
                    class="MenuRibbon-bar"
                    v-for="i in 3"
                    :key="i"
                ></span>
            </div>
            <a
                class="MenuRibbon-link"
                ref="link"
                href="http://epicmoleskine.com/2018"
            >
                <small>Ver la primera edición</small>
            </a>
        </div>
    </transition>
</template>

<script>
    import {mapGetters, mapMutations} from "vuex";
    import {IS_IN_HOME, MAIN_NAV_VISIBLE} from "@/app/store/modules/background";

    export default {
        name: 'MenuRibbon',
        methods: {
            backToHome() {
                this.setIsInHome(true);
                this.setMainNavVisible(false);
            },
            openNav() {
                this.setIsInHome(false);
                this.setMainNavVisible(true);
            },
            tweenRibbon(isOpen = true) {
                TweenLite.to(this.$refs.back, 0.5, {
                    scaleY: isOpen ? 1 : 0,
                    delay: isOpen ? 0.5 : 0,
                    ease: Sine.easeOut,
                })
            },
            tweenButton(isOpen = true) {
                TweenMax.to(this.$refs.bttn, 0.2, {
                    alpha: isOpen ? 1 : 0,
                    delay: isOpen ? 1.0 : 0,
                    ease: Sine.easeOut,
                })
            },
            tweenCloseButton(isOpen = true) {
                TweenMax.to(this.$refs.closeBttn, 0.2, {
                    y: isOpen ? 0 : -50,
                    delay: isOpen ? 0.6 : 0,
                    ease: Sine.easeOut,
                })
            },
            tweenLink(isOpen = true) {
                TweenMax.to(this.$refs.link, 0.2, {
                    y: isOpen ? 10 : -10,
                    alpha: isOpen ? 1 : 0,
                    delay: isOpen ? 1.0 : 0,
                    ease: Sine.easeOut,
                })
            },
            intro(el, done) {
                TweenLite.set(el, {alpha: 1});
                this.tweenRibbon();
                this.tweenButton();
                this.tweenLink();
                done();
            },
            outro(el, done) {
                TweenLite.to(el, 1, {
                    alpha: 0,
                    onComplete: done,
                    ease: Cubic.easeOut,
                })
            },
            ...mapMutations({
                setMainNavVisible: MAIN_NAV_VISIBLE,
                setIsInHome: IS_IN_HOME
            }),
            hideUi(value) {
                this.tweenLink(value);
                this.tweenRibbon(value);
                this.tweenButton(value);
                this.tweenCloseButton(!value);
            }
        },
        computed: {
            ...mapGetters(["mainNavVisible", "ribbonVisible", "isInHome"])
        },
        watch: {
            isInHome(value) {
                this.hideUi(value);
            }
        }
    }
</script>

<style src="styles/components/MenuRibbon.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/components/MenuRibbon.vue